// removed by extract-text-webpack-plugin
module.exports = {"settings":"style__settings__3g4QG","upgradeAccount":"style__upgradeAccount__cb8Zo","data_section":"style__data_section__5WMDB","currentPlan":"style__currentPlan__2TgUh","subscription_section":"style__subscription_section__2sOpl","error":"style__error__3MQbE","buttons":"style__buttons__1bha2","right":"style__right__1dcj5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/settings/style.scss
// module id = 236
// module chunks = 0